import { CLOSE, STOP_RULESET } from './resultTypes';
import { RULE_RESULT_CLOSE, RULE_RESULT_NORMAL, RULE_RESULT_SKIP, RULE_RESULT_STOP_RULESET } from './ruleResults';


// ActionResult -> RuleResult
function actionResultToRuleResult(actionResult) {
    switch (actionResult.status) {
        case CLOSE:
            return RULE_RESULT_CLOSE;
        case STOP_RULESET:
            return RULE_RESULT_STOP_RULESET;
        default:
            return RULE_RESULT_NORMAL;
    }
}

// (Rule, DataSourceNode) -> Boolean
function shouldRunRule(rule, context) {
    var condition = rule.condition;

    if (!rule.isEnabled) {
        return false;
    }

    return !condition || context.evaluateBoolean(condition);
}

// (ActionExecutor, Rule, DataSourceNode) -> RuleResult
async function executeRuleAsync(actionExecutor, rule, context) {
    for (const action of rule.actions.filter(a => a.supported)) {
        const result = await actionExecutor.runActionAsync(action.action, context);

        if (result && result.shouldStop) {
            return actionResultToRuleResult(result);
        }
    }

    return RULE_RESULT_NORMAL;
}


function ruleExecutor(actionExecutor) {
    return {
        // (Rule, DataSourceNode) -> RuleResult
        runRuleAsync: async (rule, context) =>
            shouldRunRule(rule, context)
                ? executeRuleAsync(actionExecutor, rule, context)
                : RULE_RESULT_SKIP,
    };
}

export default ruleExecutor;